<template>
  <div class="orderLoading">
    <div class="detailOrder dis_f_sb" v-loading="loading">
      <div class="orderLeft">
        <div class="top">
          <div class="dun dis_f_l_t">
            <div class="dis_f_l_c">
              <img src="@/images/common/dun.png" alt="" />
              <div class="div1">声明备注</div>
              <!-- <div class="div2">亏舱费需要跟具体供应商洽谈</div> -->
            </div>
            <div class="remarks">
              <div class="remarksTop">线上预订所支付的费用，仅作为支付平台的预订服务费。</div>
              <div class="remarksBottom">当您使用该舱位装船出运时，需要向舱位供应商支付该现舱出运所产生的所有费用 。</div>
            </div>
          </div>
          <div class="dunBottom">
            <div class="box dis_f_sb_c">
              <div class="left dis_f_l_c">
                <img class="boxImg" src="@/images/common/box.png" alt="" />
                <div class="boxDiv">
                  {{ detailData.containerTypeStr }}剩余:
                  {{ detailData.otherNum }}个
                </div>
              </div>
              <div class="right">
                <div class="number dis_f_l_c">
                  <div class="jiaJian hand dis_f_c_c" @click="jian()">
                    <i class="el-icon-minus"></i>
                    <!-- <span>–</span> -->
                  </div>
                  <div class="input">
                    <el-input
                      v-model="form.boxNum"
                      @change="containerInput"
                      maxlength="3"
                      @input="
                        (val) => {
                          form.boxNum = val.replace(/[^\d]/g, '');
                        }
                      "
                      placeholder=""
                    ></el-input>
                  </div>
                  <div class="jiaJian hand dis_f_c_c" @click="jia()">
                    <i class="el-icon-plus"></i>
                    <!-- <span>+</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="xieYi dis_f_sb">
              <div class="xyLeft dis_f_l_c">
                <img class="xyImg" src="@/images/common/zhu-yi.png" alt="" />
                <div class="xyContent dis_f_l_c">
                  预订服务费:
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      预订服务费收费规则<br />
                      1.预定成功收取10元/TEU预定服务费。<br />
                      2.预定成功后，舱位供应商未能按照约定价格和数量提供相对应舱位，全额退还预订服务费。<br />
                      如需帮助，请联系平台在线客服
                    </div>
                    <span class="shouFei">收费规则</span>
                  </el-tooltip>
                </div>
              </div>
              <div class="xyRight">
                共 {{ TEUData }} TEU
                <span style="margin-left: 8px; margin-right: 6px">应付</span>
                <span class="money">{{ form.price }}</span>
                <span class="company">￥</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="navTitle dis_f_l_b">
            <div>联系人</div>
            <div>
              <span>-</span> 请认真填写联系人信息，以便我们为您更好的服务
            </div>
          </div>
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            label-width="70px"
            class="el-form--order"
          >
            <el-form-item prop="orderCompany" class="mt20">
              <div slot="label">公司名称</div>
              <el-input
                v-model="form.orderCompany"
                placeholder="输入公司名称"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item prop="orderName" class="mt20">
              <div slot="label">联系人</div>
              <el-input
                v-model="form.orderName"
                placeholder="输入联系人"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item prop="orderMobile" class="mt20">
              <div slot="label">联系电话</div>
              <el-input
                v-model="form.orderMobile"
                disabled
                placeholder="输入联系电话"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="checkbox dis_f_l_c">
            <el-checkbox v-model="checked"
              ><div class="checkboxXy">
                同意并接受<span @click.stop="xieYi()"
                  >《现舱预定服务协议》</span
                >
              </div></el-checkbox
            >
          </div>
        </div>
        <div class="payButton hand dis_f_c_c" @click="saveClick">
          支付预定 {{ form.price }}￥
        </div>
      </div>
      <div class="orderRight">
        <div class="navHeader dis_f_l_c">
        <div
            class=""
            style="width: 30px; height: 30px;margin-right: 4px;"
            v-if="detailData.callFlag == 1"
          >
            <img
              class=""
              style="width: 100%"
              src="@/images/common/callflag.png"
            />
          </div>

          <img
            class="shippingLogo fit"
            :src="
              detailData.logo
                ? detailData.logo
                : require('@/images/common/shipping.png')
            "
            alt=""
            v-else
          />
          <div class="shippingName slh_one  dis_f_l_c">
           <div v-if="detailData.callFlag != 1">{{ detailData.shippingname }}，</div> 开航日 {{ detailData.etd }}
          </div>
        </div>
        <!-- 起始，终点，航程 -->
        <div class="timeline__panel">
          <!-- 起始港 目的港 -->
          <div class="timeline dis_f_sb_c">
            <div class="timeLi1">
              <div class="li1Top slh_one">{{ detailData.portstartname }}</div>
              <div class="li1Bottom slh_one">
                {{ detailData.portstartnameCn }}
              </div>
            </div>
            <div class="timeLi2 dis_f_co_c_c">
              <div class="li2Top">
                {{ detailData.voyage ? detailData.voyage + "天" : "" }}
              </div>
              <img class="li2Center" src="@/images/common/right-icon.png" />
              <div class="li2Bottom">
                {{
                  detailData.transferFlag == 1
                    ? "直达"
                    : detailData.transferFlag == 2
                    ? "中转"
                    : ""
                }}
              </div>
            </div>
            <div class="timeLi1">
              <div class="li1Top dis_f_r_c slh_one">
                <span class="slh_one">{{ detailData.portendname }}</span>
              </div>
              <div class="li1Bottom dis_f_r_c slh_one">
                <span class="slh_one">{{ detailData.portendnameCn }}</span>
              </div>
            </div>
          </div>
          <!-- 信息 -->
          <div class="timeBottom dis_f_sb_c">
            <div class="ul">
              <div class="bottomTitle">箱型</div>
              <div class="bottomContent">
                {{
                  detailData.containerTypeStr
                    ? detailData.containerTypeStr
                    : "-"
                }}
              </div>
            </div>
            <div class="ul dis_f_l_c">
              <img class="fit" src="@/images/common/xie.png" />
              <div class="price">
                <div class="bottomTitle dis_f_c_c">价格</div>
                <div class="bottomContent dis_f_c_c">
                  {{ detailData.price ? detailData.price : "-" }}
                </div>
              </div>
              <img class="fit" src="@/images/common/xie.png" />
            </div>
            <div class="ul">
              <div class="bottomTitle dis_f_r_c">亏舱费</div>
              <div class="bottomContent dis_f_r_c">
                {{ detailData.brokenPrice ? detailData.brokenPrice : "-" }}
              </div>
            </div>
          </div>
        </div>
        <!-- 数列信息 -->
        <div class="listUl">
          <div class="listLi dis_f_sb_c">
            <div>截单时间</div>
            <div>
              {{ detailData.cutBillTime ? detailData.cutBillTime : "-" }}
            </div>
          </div>
          <div class="listLi dis_f_sb_c">
            <div>截港时间</div>
            <div>
              {{ detailData.cutPortTime ? detailData.cutPortTime : "-" }}
            </div>
          </div>
          <div class="listLi dis_f_sb_c">
            <div>港区</div>
            <div>
              {{ detailData.wharfNameCn ? detailData.wharfNameCn : "-" }}
            </div>
          </div>
          <div class="listLi dis_f_sb_c">
            <div>航线代码</div>
            <div>{{ detailData.routeCode ? detailData.routeCode : "-" }}</div>
          </div>
          <div class="listLi dis_f_sb_c">
            <div>FreeTime</div>
            <!-- <div>{{ detailData.freetime ? detailData.freetime : "-" }}</div> -->
            <div v-if='detailData.freetime'>{{detailData.freetime}}天</div>
            <div v-else>-</div>
          </div>
          <div class="listLi dis_f_sb_c">
            <div>提单类型</div>
            <div>
              {{
                detailData.billType == 1
                  ? "MBL"
                  : detailData.billType == 2
                  ? "HBL"
                  : "-"
              }}
            </div>
          </div>
          <div class="listLi dis_f_sb_c">
            <div>运输条款</div>
            <div>
              {{ detailData.shippingTermsName ? detailData.shippingTermsName : "-" }}
            </div>
          </div>
        </div>
        <!-- 品名要求 备注-->
        <div class="remarks">
          <div class="title dis_f_l_c">品名要求</div>
          <div class="content dis_f_l_c">{{ detailData.commodity }}</div>
        </div>
        <div class="remarks">
          <div class="title dis_f_l_c">备注</div>
          <div class="content dis_f_l_c">
            {{ detailData.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getspacelookdetail,
  weborderpay,
} from "@/api/lookPresentCabin/lookPresentCabin";
import { isInputEmpty, isInputInteger } from "@/utils/typeCheck";
import { mapState } from "vuex";
import { decode } from "@/utils/crypto.js";
export default {
  name: "",
  data() {
    const validatorsFactory = () => {
      return new this.$CommonValidators(this);
    };
    const validatorsInstance = validatorsFactory();
    const commonValidators = validatorsInstance.validators();
    const pageValidators = {};
    const validators = {
      ...commonValidators,
      ...pageValidators,
    };
    return {
      input: "",
      form: {
        price: 0, //总价格
        boxNum: 0, //箱量
        orderName: "", //联系人项目
        orderCompany: "", //公司名
        orderMobile: "", //手机号
      },
      checked: false, //是否同意复选
      detailData: {}, //详情
      TEU: 1, //默认teu
      TEUData: 0, //teu总数量
      TEUPrice: 10, //单价
      plusReduce: 0, //加减判断 0 不显示 1 加 2 减
      id: "", //传参id
      isSubmit: "", //校验判断
      rules: {
        orderCompany: [
          {
            required: true,
            validator: validators.notEmpty,
            trigger: "blur",
            messageCn: "请输入公司名称",
            messageEn: "please input your english name",
          },
        ],
        orderName: [
          {
            required: true,
            validator: validators.notEmpty,
            trigger: "blur",
            messageCn: "请输入联系人姓名",
            messageEn: "please input your english name",
          },
        ],
        orderMobile: [
          {
            required: true,
            validator: validators.notEmpty,
            trigger: "blur",
            messageCn: "请输入联系电话",
            messageEn: "please input your english name",
          },
        ],
      },
      loading: false, //提交加载
    };
  },
  components: {},
  watch: {},
  computed: {
    ...mapState("order", {
      orderStatus: (state) => state.orderStatus,
    }),
    ...mapState("user", {
      mobile: (state) => state.mobile,
    }),
  },
  created() {
    this.id = decode(this.$route.query.id);
    // 如果改动id 或没有id 跳转首页
    if (!this.id) {
      this.$router.push("/index");
      return;
    }
    // 如果改动id 或没有id 跳转首页
    console.log("================================加密解密", this.id);
    // console.log("===========", this.mobile);
    this.lookDetail();
    this.$nextTick(() => {
      this.form.orderMobile = this.mobile;
    });
  },
  methods: {
    // 详情
    async lookDetail() {
      // ==========接口调用==========
      let res;
      let params = {
        id: this.id,
      };
      try {
        res = await getspacelookdetail(params);
        this.detailData = res;
        this.form.orderName = res.orderName
        this.form.orderCompany= res.orderCompany
        let str = this.detailData.containerTypeStr.slice(0, 2);
        console.log("str", str);
        if (str == "20") {
          this.TEU = 1;
        } else {
          this.TEU = 2;
        }
        console.log("详情", res);
      } catch (e) {
        console.error(e);
      }
    },
    // 输入
    containerInput() {
      this.TEUData = this.form.boxNum * this.TEU; //teu数量
      this.form.price = Number(this.TEUPrice) * Number(this.TEUData);
    },
    // 加
    jia() {
      if (this.form.boxNum >= this.detailData.otherNum) {
        this.$message({
          type: "warning",
          message: "请不要超过剩余箱量",
        });
        return;
      }
      this.form.boxNum = Number(this.form.boxNum) + 1;
      this.plusReduce = 1; //1加
      this.TEUData = this.form.boxNum * this.TEU; //teu数量
      this.form.price = Number(this.TEUPrice) * Number(this.TEUData);
    },
    // 减
    jian() {
      if (this.form.boxNum <= 0) {
        this.$message({
          type: "warning",
          message: "值不能小于0",
        });
      } else {
        this.form.boxNum = Number(this.form.boxNum) - 1;
        this.plusReduce = 2; //2减
        this.TEUData = this.form.boxNum * this.TEU; //teu数量

        if (this.form.boxNum == 0) {
          this.plusReduce = 0;
        }
        this.form.price = Number(this.TEUPrice) * Number(this.TEUData);
      }
    },
    // 协议
    xieYi() {
      let routeData = this.$router.resolve({
        path: "/serviceAgreement",
        query: {},
      });
      window.open(routeData.href, "_blank");
    },
    async saveClick() {
      if (isInputEmpty(this.form.boxNum)) {
        this.$message({ type: "warning", message: "箱量不能为空" });
        return;
      }
      if (this.form.boxNum <= 0) {
        this.$message({ type: "warning", message: "箱量必须大于0" });
        return;
      }
      if (!isInputInteger(this.form.boxNum)) {
        this.$message({ type: "warning", message: "箱量为整数" });
        return;
      }
      if (this.form.boxNum > this.detailData.otherNum) {
        this.$message({ type: "warning", message: "请不要超过剩余箱量" });
        return;
      }
      this.isSubmit = true;
      let checkRes = await this.$checkForm(this.$refs.form, this.rules);
      this.isSubmit = false;
      if (checkRes) {
        return;
      }
      if (!this.checked) {
        this.$message({
          type: "warning",
          message: "请仔细阅读《现舱预定服务协议》并点击接受",
        });
        return;
      }
      // 参数
      let params = {
        portStartId: this.detailData.portStartId, //起始港id
        portEndId: this.detailData.portEndId, //目的港id
        shippingId: this.detailData.shippingId, //船公司id
        etd: this.detailData.etd, //开航日
        transferFlag: this.detailData.transferFlag, //中转直达
        orderName: this.form.orderName, //联系人项目
        orderCompany: this.form.orderCompany, //公司名
        orderMobile: this.form.orderMobile, //手机号
        totalFee: this.form.price, //总价格
        spaceId: this.detailData.id, //详情id
        containerType: this.detailData.containerType, //箱型
        orderContainerNum: this.form.boxNum, //预定的箱量
      };
      // ==========接口调用==========
      let res;
      this.loading = true;
      try {
        res = await weborderpay(params);
        console.log("列表", res);
        this.loading = false;
        if (res.code == "1") {
          let object = {
            orderStatus: 2,
            code_url: res.validateMap.code_url,
            orderId: res.validateMap.orderId,
            order_form: this.form,
            object: res.validateMap, //总对象  包含code_url  orderId
          };
          this.$store.dispatch("order/orderMethods", object);
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (e) {
        console.error(e);
        this.$message({ type: "error", message: e });
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variable.scss";
.detailOrder {
  width: 1200px;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 86px;
  .orderLeft {
    width: 734px;
    .top {
      background-color: #fef4eb;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      min-height: 180px;
      margin-bottom: 10px;
      .dun {
        min-height: 44px;
        padding: 10px 0;
        padding-left: 20px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }

        .div1 {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #fd6800;
          margin-right: 9px;
        }
        .div2 {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #fd6800;
        }
        .remarks{
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #fd6800;
          line-height: 20px;
        }
      }
      .dunBottom {
        width: 734px;
        height: 136px;
        background: #ffffff;
        border-radius: 10px;
        padding-left: 20px;
        .box {
          height: 77px;
          border-bottom: 1px solid #f4f6f8;
          .left {
            .boxImg {
              width: 22px;
              height: 18px;
              margin-right: 8px;
            }
            .boxDiv {
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #333333;
            }
          }
          .right {
            margin-right: 20px;
            .number {
              .jiaJian {
                width: 28px;
                height: 28px;
                background: #ffffff;
                border: 1px solid #d2d5dc;
                border-radius: 14px;
                font-size: 16px;
                color: #c1c1c1;
                line-height: 28px;
                text-align: center;
              }
              .jiaJian:hover {
                background: var(--themeColor);
                border: 1px solid var(--themeColor);
                color: #ffffff;
              }
              .input {
                width: 194px;
                height: 28px;
                background: #ffffff;
                border: 1px solid #d2d5dc;
                border-radius: 14px;
                margin: 0 14px;
                position: relative;
                overflow: hidden;
                z-index: 1;
                /deep/.el-input {
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  top: 0;
                  left: 0;
                  z-index: 10;
                  border: none !important;
                  input {
                    text-align: center;
                    border: none !important;
                  }
                }
              }
              .inputActive {
                background: var(--themeColor);
                border: 1px solid var(--themeColor);
                color: #ffffff;
              }
            }
          }
        }
        .xieYi {
          padding-top: 14px;
          .xyLeft {
            .xyImg {
              width: 14px;
              height: 14px;
              margin-right: 6px;
            }
            .xyContent {
              .shouFei {
                color: var(--themeColor);
                cursor: pointer;
                text-decoration: underline;
                margin-left: 2px;
              }
            }
          }
          .xyRight {
            margin-right: 20px;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #676c77;
            .money {
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ff7811;
            }
            .company {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ff7811;
            }
          }
        }
      }
    }
    .bottom {
      padding: 20px 0 30px 20px;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 30px;
      .navTitle {
        div:nth-child(1) {
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        }
        div:nth-child(2) {
          font-size: 12px;
          font-family: PingFang SC;
          color: #676c77;
          margin-bottom: 2px;
          span {
            margin: 0 2px 0 4px;
          }
        }
      }
      /deep/ .el-form--order {
        @include el-form--bottom-vali(70px);
      }
      .checkbox {
        padding-top: 20px;
        .checkboxXy {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #676c77;
          span {
            color: var(--themeColor);
            text-decoration: underline;
          }
        }
      }
    }
    .payButton {
      width: 734px;
      height: 48px;
      background: var(--themeColor);
      border-radius: 10px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .orderRight {
    width: 446px;
    background: #ffffff;
    border-radius: 10px;
    padding-bottom: 50px;
    .navHeader {
      padding: 10px 0 10px 20px;
      border-bottom: 1px solid #f4f6f8;
      .shippingDX {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        border-radius: 50%;
        overflow: hidden;
        flex: none;
        font-size: 12px;
        font-weight: bold;
        color: var(--themeColor);
        background-color: var(--themeBg);
      }
      .shippingLogo {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        flex: none;
      }
      .shippingName {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #45484e;
      }
    }
    // 基本信息
    .timeline__panel {
      padding: 20px 20px;
      // 起始
      .timeline {
        margin-bottom: 20px;
        .timeLi1 {
          .li1Top {
            width: 150px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #373842;
            margin-bottom: 6px;
          }
          .li1Bottom {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #555965;
            width: 150px;
          }
        }
        .timeLi2 {
          .li2Top {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #808795;
          }
          .li2Center {
            width: 42px;
            height: 8px;
          }
          .li2Bottom {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #808795;
          }
        }
      }
      .timeBottom {
        background: #f6f8fa;
        border-radius: 4px;
        padding: 10px 20px;
        .ul {
          img {
            width: 6px;
            height: 14px;
          }
          .price {
            margin: 0 40px;
          }
          .bottomTitle {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #808795;
            margin-bottom: 2px;
          }
          .bottomContent {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #45484e;
          }
        }
      }
    }
    .listUl {
      margin: 0 20px;
      border-bottom: 1px solid #f4f6f8;
      .listLi {
        margin-bottom: 22px;
        div:nth-child(1) {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #808795;
        }
        div:nth-child(2) {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #45484e;
        }
      }
    }
    .remarks {
      .title {
        padding: 22px 20px 12px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #373842;
      }
      .content {
        padding: 0 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #676c77;
        line-height: 22px;
        text-align: left;
      }
    }
  }
}
.orderLoading {
  /deep/ .el-loading-mask {
    z-index: 10;
  }
}
</style>
<style lang="scss">
.checkbox {
  .el-checkbox {
    .el-checkbox__input {
      .el-checkbox__inner {
        border: 1px solid #e3e8ef !important;
        background-color: #e3e8ef !important;
      }
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: var(--themeColor) !important;
      border-color: var(--themeColor) !important;
    }
    .el-checkbox__label {
      padding-left: 6px !important;
    }
  }
}
</style>